import type { RouteRecordRaw } from 'vue-router'

import configTheme from '@/config/theme.json'
import LayoutMain from '@/layouts/LayoutMain.vue'

export const routes: RouteRecordRaw[] = [
  {
    name: 'index',
    path: `/:locale?`,
    redirect: (to) => ({
      name: 'search',
      params: {
        category: ' ',
        commercialization: ' ',
        locale: to.params.locale,
      },
    }),
  },
  {
    children: [
      {
        component: () => import('@/pages/PageLogin.vue'),
        name: 'login',
        path: '',
      },
    ],
    component: () => import('@/layouts/LayoutLogin.vue'),
    path: `/:locale?/login`,
    props: true,
  },
  {
    children: [
      {
        component: () => import('@/pages/CP/CPFavorites.vue'),
        meta: {
          icon: configTheme.icons.favorites,
          title: 'favorites',
        },
        name: 'cp-favorites',
        path: 'favorites',
      },
      {
        component: () => import('@/pages/CP/CPVisits.vue'),
        meta: {
          icon: 'calendar',
          title: 'visits',
        },
        name: 'cp-visits',
        path: 'visits',
      },
      {
        component: () => import('@/pages/CP/CPOffers.vue'),
        meta: {
          icon: 'myOffers',
          title: 'offers',
        },
        name: 'cp-offers',
        path: 'offers',
      },
      {
        component: () => import('@/pages/CP/CPAccountSettings.vue'),
        meta: {
          icon: 'settings',
          title: 'accountSettings',
        },
        name: 'cp-account-settings',
        path: 'account-settings',
      },
      {
        path: ':pathMatch(.*)*',
        redirect: { name: 'cp-account-settings' },
      },
    ],
    component: () => import('@/layouts/LayoutCP.vue'),
    meta: { requiresAuth: true },
    name: 'customer-panel',
    path: `/:locale?/customer-panel`,
    redirect: { name: 'cp-account-settings' },
  },
  {
    children: [
      {
        component: () => import('@/pages/PageSearch.vue'),
        meta: { notificationDeleteRequest: true },
        name: 'search',
        path: ':category/:commercialization',
        props: true,
      },
      {
        component: () => import('@/pages/ListPropertyPage.vue'),
        meta: { notificationDeleteRequest: true },
        name: 'list-property',
        path: 'list-property',
      },
      {
        name: 'list-your-property',
        path: 'list-your-property',
        redirect: (to) => ({
          name: 'list-property',
          params: {
            locale: to.params.locale,
          },
        }),
      },
      {
        component: () => import('@/pages/PageListing.vue'),
        meta: { notificationDeleteRequest: true },
        name: 'listing',
        path: 'listings/:id',
        props: true,
      },
      {
        component: () => import('@/pages/PageListing.vue'),
        name: 'listing-preview',
        path: 'previews/:id',
        props: true,
      },
      {
        component: () => import('@/pages/PageError.vue'),
        name: 'error',
        path: 'error/:status',
        props: true,
      },
    ],
    component: LayoutMain,
    path: '/:locale?',
  },
  {
    path: '/:catchAll(.*)*',
    redirect: (to) => ({
      name: 'index',
      params: { locale: to.params.locale },
    }),
  },
]
